import { combineReducers } from 'redux';
import { keywordsTiersReducer } from '@rsos/reduxDataStore';
import incidents from '@rsos/reduxDataStore/src/features/alerts/incidentsSlice';
import psaps from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import { sinatra } from '@rsos/sinatra';
import appSettings from '../app/appSlice';

const rootReducer = combineReducers({
  appSettings,
  sinatra,
  psaps,
  incidents,
  keywordTiers: keywordsTiersReducer,
});

export default rootReducer;

// The settings section now runs on the consolidated admin store, so its state
// type is the full admin state (a superset of the section's own reducers).
// Keeping the name lets section components/selectors stay unchanged.
export type { AdminState as SettingsManagementState } from '../../../reducers';
